/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import {
	FormHelperText,
	IconButton,
	InputAdornment,
	TextField,
	Tooltip,
	Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import useBusinessGroupsContainerStyles from '../BusinessGroups/BusinessGroups.styles';
import { useSnackbar } from 'notistack';
import useRequests from '@hooks/requests.hook';
import { onlyNumberAndLetter, onlyNumberAndLetterRazonSocial } from '@utils/texts';
import ErrorMessage from '@features/common/ErrorMessage/ErrorMessage';
import SightLoading from '@features/common/Loading/SightLoading';
interface Props {
	open: boolean;
	handleClose: () => void;
}
export default function AssociateClient({ open, handleClose }: Props) {
	const [search, setSearch] = useState('');
	const [list, setList] = useState<
		{ nombre: string; identificacion: string; tiene_grupo_empresarial: boolean }[]
	>([]);
	const [searchSecond, setSearchSecond] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const [listSecond, setListSecond] = useState<
		{ nombre: string; identificacion: string; tiene_grupo_empresarial: boolean }[]
	>([]);
	const classes = useBusinessGroupsContainerStyles();
	const width = document.getElementById('width')?.clientWidth;
	const [data, setData] = useState<{
		descripcion: string;
		clientes: {
			identificacion: string;
			principal: boolean;
			nombre: string;
			tiene_grupo_empresarial: boolean;
		}[];
	}>({
		descripcion: '',
		clientes: [],
	});
	const [errors, setErrors] = useState({
		description: false,
		clients: false,
		searchPrincipal: false,
		searchSecond: false,
	});
	const [openModalConfirm, setopenModalConfirm] = useState(false);
	const [openModalConfirmClients, setopenModalConfirmClients] = useState(false);
	const [openModalError, setopenModalError] = useState<boolean | string>(false);
	const [openModalClose, setopenModalClose] = useState(false);
	const { enqueueSnackbar } = useSnackbar();
	const { requestBackendSuite, requestAdministraCliente } = useRequests();

	const queryClienteByIdRazonSocial = async (identificacionMatch: string): Promise<any[]> => {
		try {
			const response = (await requestAdministraCliente(
				`clientes/busqueda/razon-social?identificacionMatch=${identificacionMatch}`,
				'GET'
			)) as any;
			if (response.isError) {
				throw new Error(response.message || response.data.message);
			}
			return Promise.resolve(response.data);
		} catch (error: any) {
			return Promise.resolve([]);
		}
	};

	useEffect(() => {
		if (searchSecond.length >= 3) {
			queryClienteByIdRazonSocial(searchSecond).then((res) => {
				setList([]);
				const newData = [];
				for (const client of res) {
					if (
						data.clientes.findIndex((i) => i.identificacion === client.identificacion) <
						0
					) {
						newData.push(client);
					}
				}
				setListSecond(newData);
			});
		} else {
			setListSecond([]);
		}
	}, [searchSecond]);

	useEffect(() => {
		if (search.length >= 3) {
			queryClienteByIdRazonSocial(search).then((res) => {
				setListSecond([]);
				setList(res);
			});
		} else {
			setList([]);
		}
	}, [search]);

	const handleClickOpen = () => {
		setopenModalConfirm(true);
	};

	const handleCloseModal = () => {
		setopenModalConfirm(false);
		setopenModalClose(false);
		setopenModalConfirmClients(false);
		setopenModalError(false);
	};

	const addClient = (
		principal: boolean,
		identificacion: string,
		nombre: string,
		tiene_grupo_empresarial: boolean
	) => {
		setErrors({ ...errors, clients: false, searchPrincipal: false });
		if (!principal) {
			setErrors({ ...errors, clients: false, searchSecond: false });
		} else {
			setErrors({ ...errors, clients: false, searchPrincipal: false });
		}
		const clientes = [...data.clientes];
		clientes.push({
			identificacion,
			principal,
			nombre,
			tiene_grupo_empresarial,
		});
		setData({ ...data, clientes, descripcion: principal ? nombre : data.descripcion });
	};

	const deleteClient = (identificacion: string, principal: boolean) => {
		if (principal) {
			return setData({ descripcion: '', clientes: [] });
		}
		const clientes = [...data.clientes];
		clientes.splice(
			clientes.findIndex((i) => i.identificacion === identificacion),
			1
		);
		setData({ ...data, clientes });
	};

	const validateForm = () => {
		const error = { ...errors };
		error.searchPrincipal = false;
		error.searchSecond = false;
		if (!data.descripcion) {
			error.description = true;
		} else {
			error.description = false;
		}
		if (data.clientes.length < 2) {
			error.clients = true;
		} else {
			error.clients = false;
		}
		setErrors(error);
		if (!error.description && !error.clients) {
			handleClickOpen();
		}
	};
	const validateGroups = () => {
		const filter = data.clientes.filter((i) => i.tiene_grupo_empresarial);
		if (filter.length > 0) {
			setopenModalConfirmClients(true);
		} else {
			onSubmit();
		}
	};
	const onSubmit = async () => {
		try {
			setIsLoading(true);
			const response = (await requestBackendSuite('grupos-empresariales', 'POST', {
				...data,
				clientes: data.clientes.map((i) => {
					return { identificacion: i.identificacion, principal: i.principal };
				}),
			})) as any;
			if (response.isError) {
				throw response.message || response.data;
			}
			enqueueSnackbar('Creado correctamente', { variant: 'success' });
			handleCloseModal();
			setList([]);
			setListSecond([]);
			setData({ descripcion: '', clientes: [] });
			setSearch('');
			setSearchSecond('');
			handleClose();
			setIsLoading(false);
		} catch (error: any) {
			setIsLoading(false);
			setopenModalError(true);
			if (error === 'El grupo empresarial tiene varios nit') {
				setopenModalError('El grupo empresarial tiene varios nit');
			} else if (error.response && error.response.data.message) {
				setopenModalError(true);
			}
		}
	};
	const close = () => {
		setList([]);
		setListSecond([]);
		setData({ descripcion: '', clientes: [] });
		setErrors({
			clients: false,
			description: false,
			searchPrincipal: false,
			searchSecond: false,
		});
		setSearch('');
		setSearchSecond('');
		handleClose();
		handleCloseModal();
	};

	return (
		<div>
			{isLoading && <SightLoading show={true} />}
			<Dialog
				open={open}
				onClose={() => {
					if (data.descripcion.length > 0 || data.clientes.length > 0) {
						setopenModalClose(true);
					} else {
						close();
					}
				}}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				style={{
					backdropFilter: 'blur(3px)',
					background: 'transparent',
				}}
				sx={{
					'& .MuiPaper-root': {
						borderRadius: '17px',
						width: '600px',
					},
				}}
			>
				<DialogTitle
					style={{
						color: '#003C82',
						fontFamily: 'Montserrat',
						fontSize: 22,
						fontWeight: 'bold',
						borderBottom: '0.5px solid rgb(0 0 0 / 4%)',
						padding: '16px 34px',
					}}
					id="alert-dialog-title"
				>
					<div style={{ position: 'absolute', marginTop: '6px' }}>Asociar clientes</div>
					<IconButton
						style={{
							float: 'right',
						}}
						sx={{
							'&:hover': {
								background: 'transparent',
							},
						}}
						onClick={() => {
							if (data.descripcion.length > 0 || data.clientes.length > 0) {
								setopenModalClose(true);
							} else {
								close();
							}
						}}
					>
						<CloseIcon style={{ fontSize: '36px', marginTop: '-5px' }} />
					</IconButton>
				</DialogTitle>
				<DialogContent
					sx={{
						'&::-webkit-scrollbar': {
							width: 6,
						},
						'&::-webkit-scrollbar-track': {
							backgroundColor: '#E9E9E9',
							borderRadius: 7,
						},
						'&::-webkit-scrollbar-thumb': {
							backgroundColor: '#c7c7c7',
							borderRadius: 7,
						},
					}}
					style={{ margin: '25px auto 0px auto', width: '95%' }}
				>
					<Typography
						color="#707070"
						fontFamily="Montserrat"
						fontSize={14}
						fontWeight={500}
						id={'width'}
					>
						{data.clientes.length === 0
							? 'Agregar cliente principal'
							: 'Cliente principal'}
					</Typography>
					<FormHelperText sx={{ position: 'relative', top: 15 }} error>
						{errors.searchPrincipal
							? '*Este cliente ya pertenece a un grupo empresarial'
							: null}
					</FormHelperText>
					{data.clientes.length === 0 ? (
						<TextField
							fullWidth
							autoCapitalize="on"
							onChange={(e) => {
								setSearch(e.target.value);
							}}
							error={Boolean(errors.searchPrincipal)}
							placeholder="Buscar..."
							size="small"
							sx={{
								marginTop: '16px',
								'& .MuiOutlinedInput-input': {
									color: '#707070',
									fontSize: 16,
								},
							}}
							value={search}
							disabled={data.clientes.length > 0}
							id="search"
							onKeyPress={(e) => {
								const tecla = document.all ? e.keyCode : e.which;
								if (tecla == 13 && list.length > 0) {
									setList([]);
									setSearch('');
									addClient(
										true,
										list[0].identificacion,
										list[0].nombre,
										list[0].tiene_grupo_empresarial
									);
								}
								onlyNumberAndLetter(e);
							}}
							autoComplete="off"
							InputProps={{
								startAdornment: (
									<>
										<InputAdornment position="start">
											<SearchIcon style={{ fontSize: 18 }} />
										</InputAdornment>
									</>
								),
							}}
						/>
					) : null}
					{list.length > 0 ? (
						<div
							style={{ width: width ? width : '30%', position: 'fixed' }}
							className={classes.divList}
						>
							<ul className={classes.ulClients}>
								{list.map((i, key) => {
									if (key < 10) {
										return (
											<li
												onClick={() => {
													setList([]);
													setSearch('');
													addClient(
														true,
														i.identificacion,
														i.nombre,
														i.tiene_grupo_empresarial
													);
												}}
												className={classes.liClients}
												key={key}
											>
												<SearchIcon
													style={{
														fontSize: 18,
														top: 3,
														position: 'relative',
													}}
												/>{' '}
												<span>
													{i.identificacion} - {i.nombre}
												</span>
											</li>
										);
									}
								})}
							</ul>
						</div>
					) : list.length === 0 && search.length > 0 ? (
						<div style={{ width }} className={classes.divList}>
							<ul className={classes.ulClients}>
								<li>
									<SearchIcon
										style={{
											fontSize: 18,
											top: 3,
											position: 'relative',
										}}
									/>{' '}
									<span>No se encontraron resultados relacionados</span>
								</li>
							</ul>
						</div>
					) : null}
					{data.clientes.length > 0 ? (
						<div style={{ marginTop: 15 }}>
							<table className={classes.table}>
								<thead>
									<tr>
										<th style={{ width: 150 }} className={classes.th}>
											N° Identificación
										</th>
										<th className={classes.th}>Razón social</th>
										<th style={{ width: '10px' }}></th>
									</tr>
								</thead>
								<tbody>
									{data.clientes.map((customer, key) => {
										if (customer.principal) {
											return (
												<tr key={key}>
													<td className={classes.td}>
														{customer.identificacion}
													</td>
													<td className={classes.td}>
														{customer.nombre}
													</td>
													<td className={classes.td}>
														<Tooltip
															classes={{
																tooltip: classes.tooltip,
																arrow: classes.arrow,
															}}
															style={{
																color: '#003C82',
																marginBottom: '2%',
																marginTop: '6%',
																marginLeft: 15,
															}}
															title="Retirar"
														>
															<IconButton
																onClick={() =>
																	deleteClient(
																		customer.identificacion,
																		true
																	)
																}
															>
																<CloseIcon
																	style={{ color: '#1063AC' }}
																/>
															</IconButton>
														</Tooltip>
													</td>
												</tr>
											);
										}
									})}
								</tbody>
							</table>
							<Typography
								color="#707070"
								fontFamily="Montserrat"
								fontSize={14}
								fontWeight={500}
								style={{ marginTop: 25 }}
							>
								Nombre de grupo empresarial
							</Typography>
							<FormHelperText sx={{ position: 'relative', top: 15 }} error>
								{errors.description ? '*El campo nombre es obligatorio' : null}
							</FormHelperText>
							<TextField
								fullWidth
								autoCapitalize="on"
								onKeyPress={onlyNumberAndLetterRazonSocial}
								onChange={(e) => {
									setErrors({ ...errors, description: false });
									setData({ ...data, descripcion: e.target.value });
								}}
								size="small"
								inputProps={{ maxLength: 100 }}
								sx={{
									marginTop: '16px',
									'& .MuiOutlinedInput-input': {
										color: '#000000A8',
										fontSize: 16,
									},
								}}
								value={data.descripcion}
								autoComplete="off"
								error={Boolean(errors.description)}
							/>
							<Typography
								color="#707070"
								fontFamily="Montserrat"
								fontSize={14}
								fontWeight={500}
								id={'width'}
								style={{ marginTop: 25 }}
							>
								Clientes del grupo
							</Typography>
							<FormHelperText sx={{ position: 'relative', top: 15 }} error>
								{errors.searchSecond
									? '*Este cliente ya pertenece a un grupo empresarial'
									: errors.clients
									? '*Debes agregar un cliente para poder crear el grupo'
									: null}
							</FormHelperText>
							<TextField
								fullWidth
								autoCapitalize="on"
								onKeyPress={(e) => {
									const tecla = document.all ? e.keyCode : e.which;
									if (tecla == 13 && listSecond.length > 0) {
										setListSecond([]);
										setSearchSecond('');
										addClient(
											false,
											listSecond[0].identificacion,
											listSecond[0].nombre,
											listSecond[0].tiene_grupo_empresarial
										);
									}
									onlyNumberAndLetter(e);
								}}
								onChange={(e) => {
									setSearchSecond(e.target.value);
									setList([]);
								}}
								placeholder="Buscar..."
								size="small"
								sx={{
									marginTop: '16px',
									'& .MuiOutlinedInput-input': {
										color: '#707070',
										fontSize: 16,
									},
								}}
								value={searchSecond}
								autoComplete="off"
								error={Boolean(errors.clients) || Boolean(errors.searchSecond)}
								InputProps={{
									startAdornment: (
										<>
											<InputAdornment position="start">
												<SearchIcon style={{ fontSize: 18 }} />
											</InputAdornment>
										</>
									),
								}}
							/>
							{listSecond.length > 0 ? (
								<div
									style={{ width: width ? width : '30%' }}
									className={classes.divList}
								>
									<ul className={classes.ulClients}>
										{listSecond.map((i, key) => {
											if (key < 10) {
												return (
													<li
														onClick={() => {
															setListSecond([]);
															setSearchSecond('');
															addClient(
																false,
																i.identificacion,
																i.nombre,
																i.tiene_grupo_empresarial
															);
														}}
														className={classes.liClients}
														key={key}
													>
														<SearchIcon
															style={{
																fontSize: 18,
																top: 3,
																position: 'relative',
															}}
														/>{' '}
														<span>
															{i.identificacion} - {i.nombre}
														</span>
													</li>
												);
											}
										})}
									</ul>
								</div>
							) : listSecond.length === 0 && searchSecond.length > 0 ? (
								<div style={{ width }} className={classes.divList}>
									<ul className={classes.ulClients}>
										<li>
											<SearchIcon
												style={{
													fontSize: 18,
													top: 3,
													position: 'relative',
												}}
											/>{' '}
											<span>No se encontraron resultados relacionados</span>
										</li>
									</ul>
								</div>
							) : null}
							{data.clientes.findIndex((i) => !i.principal) > 0 ? (
								<div style={{ marginTop: 20 }}>
									<table className={classes.table}>
										<thead>
											<tr>
												<th style={{ width: 150 }} className={classes.th}>
													N° Identificación
												</th>
												<th className={classes.th}>Razón social</th>
												<th style={{ width: '10px' }}></th>
											</tr>
										</thead>
										<tbody>
											{data.clientes.map((customer, key) => {
												if (!customer.principal) {
													return (
														<tr key={key}>
															<td className={classes.td}>
																{customer.identificacion}
															</td>
															<td className={classes.td}>
																{customer.nombre}
															</td>
															<td className={classes.td}>
																<Tooltip
																	classes={{
																		tooltip: classes.tooltip,
																		arrow: classes.arrow,
																	}}
																	style={{
																		color: '#003C82',
																		marginBottom: '2%',
																		marginTop: '6%',
																		marginLeft: 15,
																	}}
																	title="Retirar"
																>
																	<IconButton
																		onClick={() =>
																			deleteClient(
																				customer.identificacion,
																				false
																			)
																		}
																	>
																		<CloseIcon
																			style={{
																				color: '#1063AC',
																			}}
																		/>
																	</IconButton>
																</Tooltip>
															</td>
														</tr>
													);
												}
											})}
										</tbody>
									</table>
								</div>
							) : null}
						</div>
					) : null}
				</DialogContent>
				<DialogActions
					style={{
						width: '90%',
						margin: '0px auto 20px auto',
					}}
				>
					{data.clientes.length > 0 ? (
						<Button
							style={{
								background: data.clientes.length > 0 ? '#0D66B6' : '#707070',
								fontFamily: 'Montserrat',
								color: 'white',
								padding: '8px 26px',
								fontSize: 12,
								borderRadius: 10,
							}}
							disabled={data.clientes.length === 0}
							onClick={() => {
								validateForm();
							}}
						>
							GUARDAR
						</Button>
					) : null}
				</DialogActions>
			</Dialog>
			<Dialog
				open={openModalConfirm}
				onClose={handleCloseModal}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				style={{
					backdropFilter: 'blur(3px)',
					background: 'transparent',
				}}
				sx={{
					'& .MuiPaper-root': {
						borderRadius: '17px',
						width: '414px',
						height: '150px',
					},
				}}
			>
				<DialogTitle
					style={{
						color: '#003C82',
						fontFamily: 'Montserrat',
						fontSize: 18,
						fontWeight: 'bold',
						borderBottom: '0.5px solid rgb(0 0 0 / 4%)',
						padding: '16px 34px',
					}}
					id="alert-dialog-title"
				>
					¿Deseas guardar el formulario?
				</DialogTitle>
				<DialogActions style={{ marginTop: 10 }}>
					<Button
						style={{
							background: '#FFFFFF',
							fontFamily: 'Montserrat',
							color: '#686868',
							padding: '8px 26px',
							fontSize: 12,
							borderRadius: 10,
							border: '1px solid #0000001F',
							boxShadow: ' 0px 3px 10px #00000029',
						}}
						onClick={handleCloseModal}
					>
						SEGUIR EDITANDO
					</Button>
					<Button
						style={{
							background: '#0D66B6',
							fontFamily: 'Montserrat',
							color: 'white',
							padding: '8px 26px',
							fontSize: 12,
							borderRadius: 10,
							boxShadow: ' 0px 3px 10px #00000029',
							marginRight: 25,
						}}
						onClick={validateGroups}
					>
						GUARDAR
					</Button>
				</DialogActions>
			</Dialog>
			{openModalConfirmClients && (
				<Dialog
					open={openModalConfirmClients}
					onClose={handleCloseModal}
					aria-labelledby="alert-dialog-title"
					aria-describedby="alert-dialog-description"
					style={{
						backdropFilter: 'blur(3px)',
						background: 'transparent',
					}}
					sx={{
						'& .MuiPaper-root': {
							borderRadius: '17px',
							width: '605px',
							height: '216px',
						},
					}}
				>
					{data.clientes.filter((i) => i.tiene_grupo_empresarial).length > 1 ? (
						<DialogTitle
							style={{
								color: '#686868',
								fontFamily: 'Montserrat',
								fontSize: 18,
								borderBottom: '0.5px solid rgb(0 0 0 / 4%)',
								padding: '16px 34px',
							}}
							id="alert-dialog-title"
						>
							Varios clientes seleccionados ya pertenecen a un grupo empresarial.
						</DialogTitle>
					) : (
						<DialogTitle
							style={{
								color: '#686868',
								fontFamily: 'Montserrat',
								fontSize: 18,
								borderBottom: '0.5px solid rgb(0 0 0 / 4%)',
								padding: '16px 34px',
							}}
							id="alert-dialog-title"
						>
							El cliente{' '}
							<strong>
								{
									data.clientes.filter((i) => i.tiene_grupo_empresarial)[0]
										.identificacion
								}{' '}
								- {data.clientes.filter((i) => i.tiene_grupo_empresarial)[0].nombre}
							</strong>{' '}
							ya pertenece a un grupo empresarial.
						</DialogTitle>
					)}

					<p
						style={{
							color: '#003C82',
							fontFamily: 'Montserrat',
							fontSize: 18,
							fontWeight: 'bold',
							padding: '0px 34px',
							marginBottom: '10px',
						}}
					>
						¿Estas seguro que quieres asociarlo a uno nuevo?
					</p>
					<DialogActions>
						<Button
							style={{
								background: '#FFFFFF',
								fontFamily: 'Montserrat',
								color: '#686868',
								padding: '8px 26px',
								fontSize: 12,
								borderRadius: 10,
								border: '1px solid #0000001F',
								boxShadow: ' 0px 3px 10px #00000029',
							}}
							onClick={handleCloseModal}
						>
							CANCELAR
						</Button>
						<Button
							style={{
								background: '#0D66B6',
								fontFamily: 'Montserrat',
								color: 'white',
								padding: '8px 26px',
								fontSize: 12,
								borderRadius: 10,
								boxShadow: ' 0px 3px 10px #00000029',
								marginRight: 25,
							}}
							onClick={onSubmit}
						>
							ASOCIAR Y GUARDAR
						</Button>
					</DialogActions>
				</Dialog>
			)}
			{openModalError && (
				<ErrorMessage openModalError={openModalError} handleCloseModal={handleCloseModal} />
			)}
			<Dialog
				open={openModalClose}
				onClose={handleCloseModal}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				style={{
					backdropFilter: 'blur(3px)',
					background: 'transparent',
				}}
				sx={{
					'& .MuiPaper-root': {
						borderRadius: '17px',
						width: '414px',
						height: '150px',
					},
				}}
			>
				<DialogTitle
					style={{
						color: '#003C82',
						fontFamily: 'Montserrat',
						fontSize: 18,
						fontWeight: 'bold',
						borderBottom: '0.5px solid rgb(0 0 0 / 4%)',
						padding: '16px 34px',
					}}
					id="alert-dialog-title"
				>
					¿Deseas cerrar el formulario?
				</DialogTitle>
				<DialogActions style={{ marginTop: 10 }}>
					<Button
						style={{
							background: '#FFFFFF',
							fontFamily: 'Montserrat',
							color: '#686868',
							padding: '8px 26px',
							fontSize: 12,
							borderRadius: 10,
							border: '1px solid #0000001F',
							boxShadow: ' 0px 3px 10px #00000029',
						}}
						onClick={close}
					>
						Cerrar
					</Button>
					<Button
						style={{
							background: '#0D66B6',
							fontFamily: 'Montserrat',
							color: 'white',
							padding: '8px 26px',
							fontSize: 12,
							borderRadius: 10,
							boxShadow: ' 0px 3px 10px #00000029',
							marginRight: 25,
						}}
						onClick={handleCloseModal}
					>
						SEGUIR EDITANDO
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
}
